<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                                  clearable
              clear-icon="mdi-close-circle"
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                                  clearable
              clear-icon="mdi-close-circle"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                                  clearable
              clear-icon="mdi-close-circle"
                label="แผนก"
                class="ma-2"
              ></v-select>
              <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getDataQuota()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <v-spacer></v-spacer>
              <!-- ปี -->
              <v-col cols="4">
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
              ></v-select>
              </v-col>
              <!-- ค้นหา -->
             <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getDataQuota()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportLeave()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getDataQuota()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="searchAll"
              dense
              outlined
              append-icon="mdi-magnify"
              label="ค้นหา รายชื่อ"
            ></v-text-field>
          </v-col>
        </v-row>
          <!-- data table -->

        <v-col cols="12">
          <v-alert dense type="info" icon="mdi-account-switch">
            รายการ <strong>จำนวนโควต้าลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="itemsQuota"
                :search="searchAll"
                :items-per-page="10"
              >
                <template v-slot:[`item.leaveSick`]="{ item }">
                  <v-chip
                    class="ma-2"
                    color="indigo darken-3"
                    label
                    outlined
                  >
                    {{item.leaveSickQuota - item.leaveSick}}/{{item.leaveSickQuota}}
                  </v-chip>
                </template>
                <template v-slot:[`item.leaveBusiness`]="{ item }">
                  <v-chip
                    class="ma-2"
                    color="indigo darken-3"
                    label
                    outlined
                  >
                    {{item.leaveBusinessQuota - item.leaveBusiness}}/{{item.leaveBusinessQuota}}
                  </v-chip>
                </template>
                <template v-slot:[`item.leaveHoliday`]="{ item }">
                  <v-chip
                    class="ma-2"
                    color="indigo darken-3"
                    label
                    outlined
                  >
                    {{item.leaveHolidayQuota - item.leaveHoliday}}/{{item.leaveHolidayQuota}}
                  </v-chip>
                </template>
                <template v-slot:[`item.leaveOrdination`]="{ item }">
                  <v-chip
                    class="ma-2"
                    color="indigo darken-3"
                    label
                    outlined
                  >
                    {{item.leaveOrdinationQuota - item.leaveOrdination}}/{{item.leaveOrdinationQuota}}
                  </v-chip>
                </template>
                <template v-slot:[`item.leaveMaternity`]="{ item }">
                  <v-chip
                    class="ma-2"
                    color="indigo darken-3"
                    label
                    outlined
                  >
                    {{item.leaveMaternityQuota - item.leaveMaternity}}/{{item.leaveMaternityQuota}}
                  </v-chip>
                </template>
                <template v-slot:[`item.leaveUnpaid`]="{ item }">
                  <v-chip
                    class="ma-2"
                    color="indigo darken-3"
                    label
                    outlined
                  >
                    {{item.leaveUnpaidQuota - item.leaveUnpaid}}/{{item.leaveUnpaidQuota}}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <!-- end data table -->

      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import moment from 'moment'
// import LeaveRequestVue from './LeaveRequest.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  data () {
    return {
      path: '/leave_data/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการ จำนวนโควต้าลา',
          disabled: false,
          href: '/HRM/Leave/LeaveQuotaEmp'
        }
      ],
      session: this.$session.getAll(),
      menu: false,
      modal: false,
      menu1: false,
      loading: false,
      loading2: false,
      dataReady: true,
      columnsItem: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'วันเริ่มงาน', value: 'startDate' },
        { text: 'อายุงาน', value: 'workDate' },
        { text: 'ลาป่วย', value: 'leaveSick' },
        { text: 'ลากิจ', value: 'leaveBusiness' },
        { text: 'ลาพักร้อน', value: 'leaveHoliday' },
        { text: 'ลาอุปสมบท', value: 'leaveOrdination' },
        { text: 'ลาคลอด', value: 'leaveMaternity' },
        { text: 'ลาไม่รับค่าตอบแทน', value: 'leaveUnpaid' }
      ],
      profile: '',
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // สาขา
      Department: '', // แผนก
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      itemsQuota: []
    }
  },
  async mounted () {
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getDataQuota()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
  },
  methods: {
    async getDataQuota () {
      this.itemsQuota = []

      // this.Department = (this.Department) ? this.Department : null
      // this.Branch = (this.Branch) ? this.Branch : null
      // this.Company = (this.Company) ? this.Company : null

      // var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      // var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      // var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_quota/get_quota' +
          '?shiftYear=' +
            this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          this.itemsQuota = rs
          console.log('getDataitemsQuota : ', this.itemsQuota)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async exportLeave () {
      var dataItme = []
      this.itemsQuota.forEach((element) => {
        console.log('element', element)
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'ตำแหน่ง': element.positionName,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'เริ่มงาน': element.startDate,
          'อายุงาน': element.workDate,
          'ลาป่วย': (element.leaveSickQuota - element.leaveSick) + '/' + element.leaveSickQuota,
          'ลากิจ': (element.leaveBusinessQuota - element.leaveBusiness) + '/' + element.leaveBusinessQuota,
          'ลาพักร้อน': (element.leaveHolidayQuota - element.leaveHoliday) + '/' + element.leaveHolidayQuota,
          'ลาอุปสมบท': (element.leaveOrdinationQuota - element.leaveOrdination) + '/' + element.leaveOrdinationQuota,
          'ลาคลอด': (element.leaveMaternityQuota - element.leaveMaternity) + '/' + element.leaveMaternityQuota,
          'ลาไม่รับค่าตอบแทน': (element.leaveUnpaidQuota - element.leaveUnpaid) + '/' + element.leaveUnpaidQuota
        }
        dataItme.push(s)
        console.log('dataItme', dataItme)
      })
      var data = XLSX.utils.json_to_sheet(dataItme)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รายการจำนวนโควต้าลา') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'รายการจำนวนโควต้าลา.xls') // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
:root {
  --table-head-text: #ffffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
}
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Leave/LeaveQuotaEmp.vue